import request from "@/utils/request";
import base from './base';

// 删除原有的 host 定义
export const host = base.api_data;

const api_combined_data_view = '/bans/combined_data_view/'; // 更新乐檬数据
const api_get_operation_log_view = '/bans/get_operation_log_view/'; // 乐檬更新日志
const api_inventory_query_export = '/inventory/api_inventory_query_export/'; // 库存查询导出



export default {
    //更新乐檬数据
    api_combined_data_view(params) {
        return request.get(`${host}${api_combined_data_view}`, { params });
    },
    //乐檬更新日志
    api_get_operation_log_view(params) {
        return request.get(`${host}${api_get_operation_log_view}`, { params });
    },
    // 库存查询导出
    api_inventory_query_export(params) {
        return request.get(`${host}${api_inventory_query_export}`, { 
            params,
            responseType: 'blob' // 重要：设置响应类型为blob，用于下载文件
        });
    }

};
